import {PlayerReduxState} from "../types";

export default function isErrorState(state: PlayerReduxState): boolean {
  return !!state.lastUserInputResult?.errorState;
}
